import React from 'react';

import styles from './JobseekerProfileEmployerViewBody.module.css';
import BubbleButton from '../../Buttons/BubbleButton/BubbleButton';
import { getTimeAgo } from '../../../../utils/formatHelpers';
import { useTranslation } from 'react-i18next';
import { LocationBlue, WorkExpIcon } from '../../../../assets/images/icons';
import BlockLoader from '../../Loaders/BlockLoader';

function WorkExperience({ jobs, ref, paginationLoading }) {
    const { t } = useTranslation();
    return (
        <div ref={ref} className={`${styles.educationContainer} recentJobs`} id='workExperience' style={{ width: '100%', }}>
            <h2 className={styles.heading}>{t('recent_jobs')}</h2>
            {!paginationLoading ?
                jobs.map((item) => {
                    const date_info = getTimeAgo(new Date(item.updatedAt));
                    let postedAt = '';
                    postedAt = t('posted') + ' ' + date_info.count + ' ' + t('general.UI.' + date_info.unit_plural) + ' ' + t('general.UI.ago');
                    return (
                        <div className={styles.workExperienceContainer}>
                            <div className={styles.workExperienceImage}>
                                <img className={styles.workExpIcon} src={WorkExpIcon} />
                            </div>
                            <div className={styles.workExperienceBody}>
                                <div className={styles.workExperienceBodyHeader}>
                                    <div className={styles.workdExpTitleAndDesc}>
                                        <h2
                                            className={styles.heading}
                                            style={{ marginBottom: "5px", }}
                                        >{item?.title}</h2>
                                        <p className={`${styles.description} ${styles.educationDescription}`}>
                                            {item?.employerDetail.company_name}</p>
                                    </div>
                                    <div className={styles.workdExpYear}>
                                        <p className={`${styles.description} ${styles.educationDescription}`}>
                                            {postedAt}
                                        </p>
                                    </div>
                                </div>
                                <div className={styles.locationContainer}>
                                    <img className={styles.locationIcon} src={LocationBlue} />
                                    <p className={`${styles.description} ${styles.educationDescription}`} >{
                                        t('general.country.' + item?.country)}
                                    </p>
                                </div>
                                <BubbleButton
                                    to={`/jobs/${item.slug}`}
                                    headerButton>{t('general.UI.viewJob')}
                                </BubbleButton>
                            </div>
                        </div>
                    )
                }) :
                <>
                    <div style={{ margin: '10px 0', width: "100%" }}><BlockLoader height={160} /></div>
                    <div style={{ margin: '10px 0', width: "100%" }}><BlockLoader height={160} /></div>
                </>
            }
        </div>


    );
}

export default WorkExperience;
